




















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import IAccount from '@/models/IAccount'
import ITransaction from '@/models/ITransaction'
import { findContrastColor } from '@/utils'

@Component
export default class AccountTransactionList extends Vue {
  @Prop({ type: Object, default: () => null })
  public account!: IAccount | null
  @Prop({ type: Array, required: true })
  public transactions!: ITransaction[]
  @Prop({ type: Boolean, default: true })
  public filter!: boolean
  @Prop({ type: Boolean, default: true })
  public head!: boolean
  @Prop({ type: Boolean, default: false })
  public foot!: boolean
  public filteredBy: string = ''
  public findContrastColor = findContrastColor

  public get total(): number {
    return this.transactions.reduce(
      (a: number, transaction: ITransaction) => a + transaction.amount,
      0
    )
  }

  public get filteredTransactions(): ITransaction[] {
    if (!this.filteredBy) {
      return this.transactions
    }
    return this.transactions.filter(
      (transaction: ITransaction) => transaction.payBy === this.filteredBy
    )
  }

  public get isMultiUser(): boolean {
    const payBy = new Set(
      this.transactions.map((transaction: ITransaction) => transaction.payBy)
    )
    return payBy.size > 1
  }

  public get showFilter(): boolean {
    return this.filter && this.isMultiUser
  }

  public get hasMultipleCurrencies(): boolean {
    return (this.account && this.account.currencies.length > 1) || false
  }
}
